// ============================================================================
// HEAVY-LIGHT DECOMPOSITION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'heavy-light-decomposition',
  name: 'Heavy-Light Decomposition',
  category: 'Graphs',
  complexity: {
    time: 'O(log N) per query',
    space: 'O(N)'
  },
  description: 'A technique for decomposing a tree into disjoint paths to enable efficient path queries and updates. It splits the tree into heavy edges (connecting to larger subtrees) and light edges, then processes heavy paths with segment trees.'
};
